import Head from "next/head";
import React from "react";
import Image from "next/image";
import ContactUsForm from "@/components/Contact-us/ContactUsForm";
import AnimatedTitleHeader from "@/components/TitleHeader/AnimatedTitleHeader";
import CardComponent from "../../../components/Card/CardComponent";
import { ToastContainer } from "react-toastify";
import MetaTags from "@/components/seo/meta-tags";
import { BreadcrumbJsonLd, OrganizationJsonLd } from "next-seo";
import { contactUsOptions, DEFAULT_IMAGE } from "@/constastants/Constant";
import { PHONE_NUMBER_ONE, PHONE_NUMBER_TWO } from "@/constastants/Constant";
import { useSearchParams } from "next/navigation";
import LocationWrapper from "@/components/us-website/LocationWrapper";
import { getCDNImageUrl } from "@/utils/Common";

const ContactUs = () => {
  const searchParams = useSearchParams();
  const PAGE_TYPE = searchParams.get("type");
  const isNorthAmericaAds = PAGE_TYPE === "na_ads";

  const META_DESC = isNorthAmericaAds
    ? `Elchemy - Your Trusted Partner for Personal Care Ingredient Sourcing`
    : ` Have questions, ideas, or feedback? Use our contact page to reach Elchemy. Experience prompt, personalized support for all your inquiries.`;

  return (
    <LocationWrapper>
      <div className="overflow-hidden">
        <MetaTags title="Contact Elchemy" description={META_DESC} includeAlternateLink={true} />
        <BreadcrumbJsonLd
          itemListElements={[
            {
              position: 1,
              name: "Home",
              item: `${process.env.NEXT_PUBLIC_APP_URL}/`,
            },
            {
              position: 2,
              name: "Contact Us",
              item: `${process.env.NEXT_PUBLIC_APP_URL}/contact-elchemy`,
            },
          ]}
        />
        <OrganizationJsonLd
          logo={DEFAULT_IMAGE}
          legalName="BizinBiz Technologies Pvt. Ltd."
          name="Elchemy"
          address={{
            streetAddress: "3/8 2nd Floor, Asaf Ali Road",
            addressLocality: "Above Dabur India Pvt. Ltd",
            postalCode: "110002",
            addressRegion: "DL",
            addressCountry: "IN",
          }}
          contactPoint={[
            {
              telephone: `${PHONE_NUMBER_ONE.value}`,
              email: "info@elchemy.com",
            },
            {
              telephone: `${PHONE_NUMBER_TWO.value}`,
            },
          ]}
          url={process.env.NEXT_PUBLIC_APP_URL}
        />
        <div
          className="pb-12"
          style={{
            backgroundImage: `url(${getCDNImageUrl("contact-us-bg.webp")})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="px-[14px] sm:px-[16%] relative pt-14 sm:pt-16">
            <p className="absolute left-10 sm:left-28 top-2">
              <a href={"/"} className="text-[0.85rem] text-white">
                Home
              </a>
              <span className="px-1 text-white">{">"}</span>{" "}
              <span className="font-medium text-[0.9rem] text-white">
                Contact Us
              </span>
            </p>
            <ToastContainer />
            <div>
              <ContactUsForm
                options={contactUsOptions}
                isNorthAmericaAds={isNorthAmericaAds}
              />
            </div>
          </div>
        </div>

        <div className="relative mt-[3.75rem]">
          <CardComponent isNorthAmericaAds={isNorthAmericaAds} />
        </div>
      </div>
    </LocationWrapper>
  );
};

export default ContactUs;
